import React from 'react';
import { View } from 'react-native';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';

import styles from './CurrentBillCardLoading.styles';
import {
  currentBillCardUpperSectionLoadingConfig,
  currentBillCardMiddleSectionLoadingConfig,
  currentBillCardLowerSectionLoadingConfig,
  shimmerPlaceholderConfig,
} from './LoadingConfigurations/CurrentBillCardLoading.config';

const renderUpperSection = () => (
  <Shimmer
    config={currentBillCardUpperSectionLoadingConfig}
    shimmerPlaceholderConfig={shimmerPlaceholderConfig}
  />
);
const renderMiddleSection = () => (
  <Shimmer
    config={currentBillCardMiddleSectionLoadingConfig}
    shimmerPlaceholderConfig={shimmerPlaceholderConfig}
  />
);
const renderLowerSection = () => (
  <Shimmer
    config={currentBillCardLowerSectionLoadingConfig}
    shimmerPlaceholderConfig={shimmerPlaceholderConfig}
  />
);

const CurrentBillCardLoading = () => {
  return (
    <>
      <View style={styles.container}>{renderUpperSection()}</View>
      {renderMiddleSection()}
      <View style={styles.container}>{renderLowerSection()}</View>
    </>
  );
};

export default CurrentBillCardLoading;
